import * as React from 'react';
import { useState } from 'react';

export interface LoadingContext {
    loading: boolean;
    loadData: boolean;
    setLoading: React.Dispatch<React.SetStateAction<boolean>>;
    startLoading: React.Dispatch<React.SetStateAction<void>>;
    stopLoading: React.Dispatch<React.SetStateAction<void>>;
}

const initState: LoadingContext = {
    loading: {} as boolean,
    loadData: {} as boolean,
    setLoading: () => {},
    startLoading: () => {},
    stopLoading: () => {},
};

const eventContext = React.createContext<LoadingContext>(initState);

export function LoadingProvider(props: Readonly<{ children: React.ReactNode }>): React.ReactElement {
    const [loading, setLoading] = useState<boolean>(true);
    const [loadData, setloadData] = useState<boolean>(false);
    let timer: NodeJS.Timeout | null = null;

    const startLoading = () => {
        timer = setTimeout(() => {
            if (timer) {
                setloadData(true);
            }
        }, 400);
    };

    const stopLoading = () => {
        if (timer) {
            clearTimeout(timer);
            timer = null;
        }

        setloadData(false);
    };
    return (
        <eventContext.Provider
            value={{
                loading: loading,
                setLoading: setLoading,
                startLoading: startLoading,
                stopLoading: stopLoading,
                loadData: loadData,
            }}
        >
            {props.children}
        </eventContext.Provider>
    );
}

export function useLoadingContext() {
    return React.useContext(eventContext);
}
